var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[[_c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":this.url,"title":"W3Schools Free Online Web Tutorials"}})])],_c('div',[_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"}},[_vm._v("Voltar")])],1)],1)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }